import { Routes } from '@angular/router';
import { WorkspaceLayoutComponent } from './layouts/workspace-layout/workspace-layout.component';
import { AuthGuard } from './shared/auth/guards/auth.guard';
import {
  ANY_BRANCH_WILDCARD,
  ANY_WORKSPACE_WILDCARD,
  BRANCH_ID_PARAM,
  BranchGuard,
  SelectedBranchGuard,
  SelectedWorkspaceGuard,
  WORKSPACE_ID_PARAM,
  WorkspaceGuard,
} from '@tokenbox/services';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { environment } from '../environments/environment.development';
import { SelectedThemeGuard } from './shared/services/themes/selected-theme.guard.ts';

export const routes: Routes = !environment.showMaintenancePage
  ? [
      {
        path: '',
        canActivate: [
          AuthGuard,
          SelectedWorkspaceGuard,
          SelectedBranchGuard,
          SelectedThemeGuard,
        ],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: '',
            redirectTo: `workspaces/${ANY_WORKSPACE_WILDCARD}/branches/${ANY_BRANCH_WILDCARD}`,
            pathMatch: 'full',
          },
          {
            path: `workspaces/:${WORKSPACE_ID_PARAM}`,
            canActivate: [WorkspaceGuard],
            runGuardsAndResolvers: 'always',
            children: [
              {
                path: '',
                redirectTo: `branches/${ANY_BRANCH_WILDCARD}`,
                pathMatch: 'full',
              },
              {
                path: `branches/:${BRANCH_ID_PARAM}`,
                component: WorkspaceLayoutComponent,
                canActivate: [BranchGuard],
                runGuardsAndResolvers: 'always',
                loadChildren: () =>
                  import('./pages/workspaces/workspaces.routes').then(
                    (m) => m.workspacesRoutes,
                  ),
              },
            ],
          },
          {
            path: 'admin',
            component: AdminLayoutComponent,
            loadChildren: () =>
              import('./pages/admin/admin.routes').then((m) => m.adminRoutes),
          },
        ],
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ]
  : [
      {
        path: '**',
        loadComponent: () =>
          import('./pages/maintenance/maintenance-page.component').then(
            (c) => c.MaintenancePageComponent,
          ),
      },
    ];
